import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { DialogProvider } from './shared/DialogContext';
import { ErrorBoundary } from './components/ErrorBoundary';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <DialogProvider>
        <App />
      </DialogProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
